// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1350":"dc9a6bb3f5f22c7b","2888":"fb1d711c610fcff2"}[chunkId] + ".css";
};